import { moneyAmountLabel } from '@/utils/formatCurrency';

export type SpMatchType = 'EXACT' | 'PHRASE' | 'BROAD';
export type SbMatchType = 'exact' | 'phrase' | 'broad';

type KeywordFieldsProps = {
  keywordText: string;
  onKeywordTextChange: (value: string) => void;
  matchType: string;
  onMatchTypeChange: (value: string) => void;
  bid: string;
  onBidChange: (value: string) => void;
  matchTypeOptions: Array<{ value: string; label: string }>;
  disabled?: boolean;
};

export function KeywordFields({
  keywordText,
  onKeywordTextChange,
  matchType,
  onMatchTypeChange,
  bid,
  onBidChange,
  matchTypeOptions,
  disabled = false,
}: KeywordFieldsProps) {
  return (
    <fieldset className="border border-border rounded-xl p-4 space-y-3">
      <legend className="text-sm font-medium text-foreground-muted px-1">
        Keyword <span className="font-normal text-foreground-subtle">(optional)</span>
      </legend>
      <div>
        <label className="block text-sm font-medium text-foreground-muted mb-1">Keyword text</label>
        <input
          type="text"
          value={keywordText}
          onChange={(e) => onKeywordTextChange(e.target.value)}
          className="w-full border border-border rounded-lg px-3 py-2"
          disabled={disabled}
          placeholder="e.g. soap bar"
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-medium text-foreground-muted mb-1">Match type</label>
          <select
            value={matchType}
            onChange={(e) => onMatchTypeChange(e.target.value)}
            className="w-full border border-border rounded-lg px-3 py-2 text-sm"
            disabled={disabled}
          >
            {matchTypeOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground-muted mb-1">{moneyAmountLabel('Bid')}</label>
          <input
            type="number"
            step="0.01"
            min="0.01"
            value={bid}
            onChange={(e) => onBidChange(e.target.value)}
            className="w-full border border-border rounded-lg px-3 py-2"
            disabled={disabled}
          />
        </div>
      </div>
      <p className="text-xs text-foreground-subtle">
        Leave keyword text empty to skip keyword creation.
      </p>
    </fieldset>
  );
}
